import { popupSteps } from "../../../../../store/common/constants";
import { getCurrentFormStep, getTargetTariffType } from "../selectors";
export var handleSecondaryButtonClick = function handleSecondaryButtonClick() {
  return function (_dispatch, getState) {
    var state = getState();
    var currentStep = getCurrentFormStep(state);
    var _getTargetTariffType = getTargetTariffType(state),
      tariffUrl = _getTargetTariffType.tariffUrl;
    if (currentStep === popupSteps.addressRequestForm) {
      // метод ссылки для конструктора
      window.location.href = tariffUrl;
    }
  };
};